module.exports = __webpack_public_path__ + "img/logo30px.a89859e3.svg";